import { createFileRoute } from '@tanstack/react-router';
import { Megaphone } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/publicacoes')({
  component: PublicacoesPage,
});

function PublicacoesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Anual"
      title="Publicações"
      description="Publicações obrigatórias do exercício no Diário Oficial."
      icon={Megaphone}
      bullets={[
        'Editais, atas e atos publicados',
        'Anexo do recorte do diário',
        'Data e veículo de publicação',
      ]}
      etaLabel="próxima fase"
    />
  );
}
